import React from 'react';
import { GlobeIcon, HeartPulseIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-sky-100 bg-white px-4 py-12" data-id="element-150" data-mp="3gfiswe27a3c0">
      <div className="mx-auto max-w-4xl text-center" data-id="element-151" data-mp="32nun0sijob3h">
        <p className="inline-flex items-center gap-2 font-display text-lg font-bold text-accent" data-id="element-152" data-mp="32pfeuadh5fxn">
          <HeartPulseIcon className="h-5 w-5 text-primary" data-id="element-153" data-mp="36pzaf9iegbho" /> COMPRA DIGITAL YA™
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-154" data-mp="3ugbqj7nstejc">
          El sistema N°1 para el cuidado de espalda y columna en Argentina.
        </p>
        <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-155" data-mp="36czunggsbik">
          Porque tu espalda merece un programa real, no ejercicios sueltos de internet.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-medium text-slate-600 sm:flex-row sm:gap-6" data-id="element-156" data-mp="3qbvm7atu2f68">
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-accent" href="mailto:compradigitalyaa@gmail.com" data-id="element-157" data-mp="2eya05yj9stox">
            <MailIcon className="h-4 w-4" data-id="element-158" data-mp="3l9sk795mt0ql" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-accent" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-159" data-mp="3gbqxme8zyjad">
            <GlobeIcon className="h-4 w-4" data-id="element-160" data-mp="3qazp90ge3ltk" /> www.compradigitalya.com
          </a>
        </div>
        <p className="mt-7 border-t border-sky-100 pt-6 text-xs font-medium text-slate-400" data-id="element-161" data-mp="80nskgzggmbt">
          © Compra Digital Ya™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}